module.exports = __webpack_public_path__ + "img/octicon_goal-16.31bf4909.svg";